import { AppError } from '@repo/error';
import { errorMessage, t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
import { Button } from '@repo/ui/button';

interface OrganizationsTableErrorStateProps {
  error: unknown;
  onRefetch: () => void;
}

export function OrganizationsTableErrorState({
  error,
  onRefetch,
}: OrganizationsTableErrorStateProps) {
  useLocale();

  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <p className="mb-2 font-semibold text-lg">{t('workspace.errorLoadingOrganizations')}</p>
      <p className="mb-4 text-muted-foreground">{errorMessage(AppError.parse(error))}</p>
      <Button className="text-primary text-sm hover:underline" onClick={onRefetch}>
        {t('workspace.tryAgain2')}{' '}
      </Button>
    </div>
  );
}
